import type { AgentConfiguratorState } from '../types/agentConfigurator';

const CONNECTOR_PENDING_CONFIG_KEY = 'connector_pending_config';

export function stashConnectorPendingConfig(cfg: AgentConfiguratorState): void {
  try {
    sessionStorage.setItem(CONNECTOR_PENDING_CONFIG_KEY, JSON.stringify(cfg));
  } catch {
    // ignore quota / private mode
  }
}

export function hasConnectorPendingConfig(): boolean {
  try {
    return sessionStorage.getItem(CONNECTOR_PENDING_CONFIG_KEY) != null;
  } catch {
    return false;
  }
}

export function takeConnectorPendingConfig(): AgentConfiguratorState | null {
  try {
    const raw = sessionStorage.getItem(CONNECTOR_PENDING_CONFIG_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(CONNECTOR_PENDING_CONFIG_KEY);
    const parsed = JSON.parse(raw) as AgentConfiguratorState;
    if (parsed?.coordinator && Array.isArray(parsed.workers)) {
      return parsed;
    }
  } catch {
    try {
      sessionStorage.removeItem(CONNECTOR_PENDING_CONFIG_KEY);
    } catch {
      // ignore
    }
  }
  return null;
}
